import SalesChallenge from './pages/SalesChallenge/SalesChallenge';
export default SalesChallenge;
